<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormCpmunicipio" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objCpMunicipio.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objCpMunicipio.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
						
					<!-- <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="IdEstado">Estado</label>
							<select @change="SetClaveEstado(item.Clave)" v-model="objCpMunicipio.IdEstado" class="form-control-search form-select" id="IdEstado">
								<option value="0">Seleccione una opción</option>
								<option v-for="(item, index) in Estados" :key="index" :value="item.IdEstado">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdEstado" :Mensaje="'*'+errorvalidacion.IdEstado[0]"/>
						</div>
					</div> -->
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="IdEstado">Estado</label>
							<select @change="SetClaveEstado()" v-model="objCpMunicipio.IdEstado" class="form-control-search form-select" id="IdEstado">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Estados" :key="index" :value="item.IdEstado">{{item.Clave + ' - ' + item.Nombre}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.IdEstado" :Mensaje="'*'+errorvalidacion.IdEstado[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="ClaveEstado">Clave Estado</label>
							<input disabled type="text" v-model="objCpMunicipio.ClaveEstado" class="form-control" id="ClaveEstado" placeholder="Ingresar Clave Estado" />
							<CValidation v-if="this.errorvalidacion.ClaveEstado" :Mensaje="'*'+errorvalidacion.ClaveEstado[0]"/>
						</div>
					</div>

					<!-- <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="ClaveEstado">Clave Estado</label>
							<input type="text" v-model="objCpMunicipio.ClaveEstado" class="form-control" id="ClaveEstado" placeholder="Ingresar Clave Estado" />
							<CValidation v-if="this.errorvalidacion.ClaveEstado" :Mensaje="'*'+errorvalidacion.ClaveEstado[0]"/>
						</div>
					</div> -->
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCpMunicipio',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCpMunicipio: {
				IdMunicipio: 0,
				Nombre: '',
				Clave: '',
				ClaveEstado: '',
				IdEstado: "",
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			Estados: [],
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCpMunicipio.IdMunicipio == 0) {
				await this.$http.post(
					'cpMunicipios',this.objCpMunicipio
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'cpMunicipios/'+this.objCpMunicipio.IdMunicipio,
					this.objCpMunicipio
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "cpMunicipios/"+this.objCpMunicipio.IdMunicipio
            ).then((res) => {
                this.objCpMunicipio = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objCpMunicipio.Fecha.replace(/-/g,'\/');
                this.objCpMunicipio.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCpMunicipio = {
				IdMunicipio: 0,
				Nombre: '',
				Clave: '',
				ClaveEstado: '',
				IdEstado: "",
            }
            this.errorvalidacion = [];
        },
		GetEstados()
		{
			this.$http.get("cpEstados", {
				params:{
					simple: 1,
				}
			}).then((res) => {
				this.Estados = res.data.data;
			});
		},
		SetClaveEstado(){
			if(this.objCpMunicipio.IdEstado){
				let index=this.Estados.findIndex((Estado)=>Estado.IdEstado==this.objCpMunicipio.IdEstado);
				this.objCpMunicipio.ClaveEstado=this.Estados[index].Clave;
			} else {
				this.objCpMunicipio.ClaveEstado='';
			}
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
			this.GetEstados();
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCpMunicipio.IdMunicipio = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
